import { fireLinkTag } from './tagManager';

export default function tagProductTitleClick() {
  const eventName = 'brand click';

  fireLinkTag({ event_name: eventName, link_name: eventName }, true);
}
